import { Flower2, Gem, HeartHandshake, MapPin, Sparkles } from "lucide-react";
import { Overline, Reveal } from "./Reveal";

const FEATURES = [
    {
        icon: Gem,
        title: "Premium Ambience",
        text: "A calm and sophisticated environment designed for relaxation.",
    },
    {
        icon: Flower2,
        title: "Personalized Experience",
        text: "Thoughtfully designed experiences to help every guest unwind.",
    },
    {
        icon: MapPin,
        title: "Prime Vashi Location",
        text: "Conveniently located in Vashi, Navi Mumbai.",
    },
    {
        icon: HeartHandshake,
        title: "Dedicated Service",
        text: "A welcoming and attentive approach throughout your visit.",
    },
    {
        icon: Sparkles,
        title: "Luxury Wellness",
        text: "An elevated spa experience focused on relaxation and rejuvenation.",
    },
];

const WhyUs = () => (
    <section data-testid="why-us-section" className="relative py-28 md:py-36">
        <div className="mx-auto max-w-7xl px-6 md:px-12">
            <div className="mb-16 text-center md:mb-20">
                <Reveal>
                    <Overline centered>Why Choose Us</Overline>
                </Reveal>
                <Reveal delay={0.1}>
                    <h2 className="mt-6 font-serif text-4xl leading-tight tracking-tight text-cream sm:text-5xl">
                        Why{" "}
                        <span className="italic text-gold-light">
                            Flammingo?
                        </span>
                    </h2>
                </Reveal>
            </div>
            <div className="grid gap-px border border-gold/15 bg-gold/15 sm:grid-cols-2 lg:grid-cols-6">
                {FEATURES.map((feature, i) => (
                    <Reveal
                        key={feature.title}
                        delay={i * 0.08}
                        className={
                            i < 2
                                ? "lg:col-span-3"
                                : "sm:col-span-1 lg:col-span-2"
                        }
                    >
                        <div
                            data-testid={`why-feature-${feature.title.toLowerCase().replace(/\s+/g, "-")}`}
                            className="group flex h-full flex-col items-start bg-emerald-950 p-9 transition-colors duration-500 hover:bg-emerald-900/60 md:p-10"
                        >
                            <feature.icon
                                size={26}
                                strokeWidth={1.25}
                                className="text-gold transition-transform duration-500 group-hover:-translate-y-1"
                                aria-hidden="true"
                            />
                            <h3 className="mt-6 font-serif text-xl tracking-wide text-cream md:text-2xl">
                                {feature.title}
                            </h3>
                            <p className="mt-3 text-sm font-light leading-relaxed tracking-wide text-sage/85">
                                {feature.text}
                            </p>
                        </div>
                    </Reveal>
                ))}
            </div>
        </div>
    </section>
);

export default WhyUs;
